import { useEffect, useState } from "react";
import Top from "../components/organisms/top";
import locale_portal from "../locale/portal.json";
import Row from "../components/atoms/row";
import Column from "../components/atoms/column";
import Spacer from "../components/atoms/spacer";
import toast from "react-hot-toast";
import { database as db } from "../../index";
import { functions as fn } from "../../index";
import { addDoc, collection, doc, getDoc } from "firebase/firestore";
import Bottom from "../components/organisms/bottom";
import locale_questionnaire from "../locale/questionnaire.json";
import { useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";

const categories = ["Team Member", "Direct Report", "Team Commissioner", "Stakeholder"];

export default function Start() {

  const doInvite = httpsCallable(fn, "inviteParticipants");

  const text_portal = JSON.parse(JSON.stringify(locale_portal));
  const text_questionnaire = JSON.parse(JSON.stringify(locale_questionnaire));

  const link = new URL(document.URL);
  const params = link.searchParams;

  const coachId = params.get("c");
  const questionnaireId = params.get("q");

  const [questionnaire, setQuestionnaire] = useState(null);
  const [coach, setCoach] = useState(null);
  const [participantName, setParticipantName] = useState("");
  const [participantEmail, setParticipantEmail] = useState("");
  const [participantCategory, setParticipantCategory] = useState("Team Member");
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const btnInvite = document.getElementById("btn_individual");

  useEffect(() => {
    (async function () {

      if (!(coachId && questionnaireId)) {
        setIsLoading(false);
        setHasError(true);
        return;
      }

      const coachLocation = doc(collection(db, "Coaches"), coachId);
      const questionnaireLocation = doc(collection(coachLocation, "Questionnaires"), questionnaireId);
      
      const coachDoc = await getDoc(coachLocation);
      const questionnaireDoc = await getDoc(questionnaireLocation);

      if (!questionnaireDoc.exists() || !coachDoc.exists()) {
        setIsLoading(false);
        setHasError(true);
        return;
      }

      const coachData = coachDoc.data();
      const questionnaireData = questionnaireDoc.data();

      setCoach(coachData)
      setQuestionnaire(questionnaireData);
      setIsLoading(false);

    })();
  }, []);

  const navigate = useNavigate();

  const inviteParticipant = () => {

      if (!questionnaire || !questionnaire.open || !coach) {
        return;
      }
  
      const questionnaireLOC = doc(collection(doc(collection(db, `Coaches`), coachId), `Questionnaires`), questionnaireId)
      const participantsLOC = collection(questionnaireLOC, `Participants`);

      const pCAT = participantCategory;
      const pEMA = participantEmail;
      const pNAM = participantName;

      if (!/^[\p{L}\p{N} !()#$£"%&'+,./:;<>?@_~-]{0,128}$/u.test(pNAM)) {
          toast.error("Your full name must be 1 to 128 characters, including letters, numbers, and some symbols. Please try again.")
          return;
      }

      if (!/^[\p{L}\p{N} !()#$£"%&'+,./:;<>?@_~-]{0,128}$/u.test(pEMA) || !/^[^@]*@[^@]*$/.test(pEMA))
      {
          toast.error("Your email address must be 1 to 128 characters, including letters, numbers, and some symbols. Please try again.")
          return;
      }

      if (!categories.includes(pCAT)) {
          toast.error("Your participant category must be: Team Member, Direct Report, Team Commissioner, or Stakeholder. Please try again.")
          return;
      }

      const data = {
          full_name: pNAM,
          email_address: pEMA,
          category: pCAT,
          q1: 0,
          q2: 0,
          q3: 0,
          q4: 0,
          q5: 0,
          q6: 0,
          q7: 0,
          q8: 0,
          q9: 0,
          q10: 0,
          q11: 0,
          q12: 0,
          q13: 0,
          q14: 0,
          q15: 0,
          q16: 0,
          q17: 0,
          q18: 0,
          q19: 0,
          q20: 0,
          q21: 0,
          q22: 0,
          q23: 0,
          q24: 0,
          q25: 0,
          q26: 0,
          q27: 0,
          q28: 0,
          q29: 0,
          q30: 0,
          q31: 0,
          q32: 0,
          q33: 0,
          q34: 0,
          q35: 0,
          q36: 0,
          q37: 0,
          q38: 0,
          q39: 0,
          q40: 0,
          q41: 0,
          q42: 0,
          qTS: "",
          qAD: "",
          qIA: ""
      };

      const settings = {
          merge: false
      };

      const btn = btnInvite;
      btn.style.opacity = "50%";
      btn.disabled = true;

      toast.promise(addDoc(participantsLOC, data, settings)
      .then((reference) => {
          const link = `https://creating-the-team-edge.web.app/team360?c=${coachId}&q=${questionnaireId}&p=${reference.id}`;
          const data = {
              participantName: `${pNAM}`,
              participantEmail: `${pEMA}`,
              participantCategory: `${pCAT}`,
              teamName: questionnaire.team_name,
              deadlineDate: questionnaire.deadline,
              questionnaireLink: link,
              coachName: `${coach.first_name} ${coach.last_name}`,
              coachEmail: coach.email_address
          };
          toast.promise(doInvite(data)
          .catch((error) => {console.error(error)})
          .finally(() => {
              navigate(`/team360?c=${coachId}&q=${questionnaireId}&p=${reference.id}`)
            }), {
              loading: `Sending an invite email to your email...`,
              success: `Successfully sent an invite email to your email.`,
              error: `We were unable to send an invite email to your email.`
          })
      })
      .finally(() => {
          btn.style.opacity = "100%";
          btn.disabled = false;
      }), {
          loading: `Adding you to the Team 360 Questionnaire`,
          success: `Successfully added you to the Team 360 Questionnaire`,
          error: `We were unable to add you to the Team 360 Questionnaire. Please check your internet connection and try again.`
      })

  }

  if (isLoading) {
    return(
      <>
        <Top title="Loading..." hero="This Team 360 Questionnaire is loading..." />
        <Bottom />
      </>
    );
  }

  if (!questionnaire || !coach || hasError) {
    return(
      <>
        <Top title="Couldn't Fetch" hero="This Team 360 Questionnaire couldn't be fetched" />
        <Bottom />
      </>
    );
  }

  if (!questionnaire.open) {
    return(
      <>
        <Top title="Currently Closed" hero="You must be invited to participate in this Team 360 Questionnaire" />
        <Bottom />
      </>
    );
  }

  return(
    <>
      <Top title="Start Now" hero={ `Welcome to ${questionnaire.team_name}`} />
      <Spacer />
      <main>
        <Row><Column size="100" side="left">
          <h2>Complete the form below to start</h2><br /><br />
          <details class="info" id="categories">
              <summary>{text_questionnaire["categories"]["title"]}</summary>
              <ul class="categories">
                  <li><h3>{text_questionnaire["categories"]["Team Member"]}</h3></li>
                  <li><h3>{text_questionnaire["categories"]["Direct Report"]}</h3></li>
                  <li><h3>{text_questionnaire["categories"]["Team Commissioner"]}</h3></li>
                  <li><h3>{text_questionnaire["categories"]["Stakeholder"]}</h3></li>
              </ul>
          </details><br /><br />
          <label htmlFor="participant_full_name">{text_portal["team360"]["actions"]["append"]["name"]}</label><br/>
          <input type="text" id="participant_full_name" placeholder="Please type here..." value={participantName} onChange={(event) => setParticipantName(event.target.value)} />
          <br />
          <label htmlFor="participant_email_address">{text_portal["team360"]["actions"]["append"]["email"]}</label><br/>
          <input type="email" id="participant_email_address" placeholder="Please type here..." value={participantEmail} onChange={(event) => setParticipantEmail(event.target.value.replaceAll(" ", "").replaceAll(",", "").toLowerCase())} />
          <br />
          <label htmlFor="participant_category">{text_portal["team360"]["actions"]["append"]["category"]}</label><br/>
          <select id="participant_category" value={participantCategory} onChange={(event) => setParticipantCategory(event.target.value)} >
              <option value="Team Member">Team Member</option>
              <option value="Direct Report">Direct Report</option>
              <option value="Team Commissioner">Team Commissioner</option>
              <option value="Stakeholder">Stakeholder</option>
          </select>
          <br /><br />
          <button class="primary" id="btn_individual" onClick={inviteParticipant} disabled={isLoading || hasError || !questionnaire || !questionnaire.open}>Start Now</button><br /><br />
        </Column></Row>
      </main>
      <Spacer />
      <Bottom />
    </>
  );

}